// New 4-Tier Pricing Structure
export const newPricingStructure = [
  {
    id: 1,
    name: "Basic",
    price: 45,
    description: "*(Govt. filing fee not included)",
    // subtitle: "Basic trademark filing service",
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Deluxe",
    price: 145,
    description: "*(Govt. filing fee not included)",
    // subtitle: "Enhanced filing with comprehensive search",
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured",
      "Direct Hit Search",
      "Dedicated Case Manager"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Premium",
    price: 299,
    description: "*(Govt. filing fee not included)",
    // subtitle: "Comprehensive filing with full legal support",
    features: [
      "Case Review (by a TM Expert)",
      "Basic Free Trademark Search",
      "Trademark Monitoring Services (3 Months)",
      "Trademark Secured",
      "Refusal Risk Meter",
      "Case filing service with complete paperwork"
    ],
    popular: false
  },
  {
    id: 4,
    name: "Elite",
    price: 599,
    description: "*(Govt. filing fee not included)",
    // subtitle: "The most comprehensive trademark protection",
    features: [
      "Case Review & Filing (U.S Registered IP Attorney)",
      "Assigned Case Filing Officer",
      "Private Registration",
      "Trademark Secured",
      "Federal Search & Clearance Report (All States)",
      "Federal E-Filing (USPTO)",
      "Cease & Desist Letter",
      "Same Day Filing",
      "Trademark Monitoring (1 Year)",
      "Trademark Secured",
      "Direct Hit Search",
      "Dedicated Case Manager",
      "24/7 Secure Online Access",
      "100% Approval Guarantee"
    ],
    popular: false
  }
];

// Service-specific pricing data (Old structure - keeping for compatibility)

export const trademarkPricing = [
  {
    id: 1,
    name: "Basic",
    price: 799,
    description: "+ Filing Fee | Essential trademark protection",
    popular: false,
    features: [
      "Comprehensive Trademark Search",
      "Single Class Registration",
      "USPTO Filing Included",
      "Basic Office Action Response",
      "Email Support"
    ]
  },
  {
    id: 2,
    name: "Professional",
    price: 1499,
    description: "+ Filing Fee | Complete trademark solution",
    popular: true,
    features: [
      "Everything in Basic",
      "Up to 3 Class Registrations",
      "Priority Filing Service",
      "Advanced Office Action Responses",
      "Trademark Monitoring (1 Year)",
      "Phone & Email Support"
    ]
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    description: "Full-service IP protection",
    popular: false,
    features: [
      "Everything in Professional",
      "Unlimited Class Registrations",
      "International Filing Support",
      "Dedicated Account Manager",
      "24/7 Priority Support",
      "Litigation Support"
    ]
  }
];

export const copyrightPricing = [
  {
    id: 1,
    name: "Single Work",
    price: 299,
    description: "One creative work registration",
    popular: false,
    features: [
      "Copyright Application",
      "Copyright Office Filing",
      "Electronic Filing",
      "Status Tracking",
      "Registration Certificate"
    ]
  },
  {
    id: 2,
    name: "Collection",
    price: 499,
    description: "Multiple related works",
    popular: true,
    features: [
      "Everything in Single Work",
      "Group Registration",
      "Up to 10 Related Works",
      "Expedited Processing",
      "Attorney Review"
    ]
  },
  {
    id: 3,
    name: "Portfolio",
    price: 999,
    description: "Large work collection",
    popular: false,
    features: [
      "Everything in Collection",
      "Unlimited Works",
      "Multiple Applications",
      "Strategic Filing Plan",
      "Priority Support"
    ]
  }
];

export const llcFormationPricing = [
  {
    id: 1,
    name: "Basic LLC",
    price: 499,
    description: "Essential LLC formation",
    popular: false,
    features: [
      "Articles of Organization",
      "State Filing",
      "EIN Application",
      "Basic Operating Agreement",
      "Membership Certificates"
    ]
  },
  {
    id: 2,
    name: "Complete LLC",
    price: 999,
    description: "Full LLC package",
    popular: true,
    features: [
      "Everything in Basic",
      "Custom Operating Agreement",
      "Initial Resolutions",
      "Registered Agent Service (1 Year)",
      "Compliance Calendar",
      "Attorney Review"
    ]
  },
  {
    id: 3,
    name: "Multi-State LLC",
    price: 1999,
    description: "Multiple state registration",
    popular: false,
    features: [
      "Everything in Complete",
      "Foreign Qualification",
      "Up to 3 Additional States",
      "Multi-State Compliance",
      "Registered Agent (All States)",
      "Ongoing Support"
    ]
  }
];

export const cCorpPricing = [
  {
    id: 1,
    name: "Basic C Corp",
    price: 999,
    description: "Essential corporation formation",
    popular: false,
    features: [
      "Articles of Incorporation",
      "State Filing",
      "Standard Bylaws",
      "EIN Application",
      "Initial Stock Issuance"
    ]
  },
  {
    id: 2,
    name: "Investor-Ready Corp",
    price: 2499,
    description: "VC-ready corporate structure",
    popular: true,
    features: [
      "Everything in Basic",
      "Custom Bylaws",
      "Board Resolutions",
      "Stock Purchase Agreements",
      "83(b) Election Support",
      "Capitalization Table",
      "Registered Agent (1 Year)"
    ]
  },
  {
    id: 3,
    name: "Delaware C Corp",
    price: 3499,
    description: "Delaware incorporation",
    popular: false,
    features: [
      "Everything in Investor-Ready",
      "Delaware Incorporation",
      "Founder Stock Documents",
      "Vesting Agreements",
      "Board Advisory",
      "Ongoing Compliance",
      "Attorney Consultation"
    ]
  }
];

export const sCorpPricing = [
  {
    id: 1,
    name: "Basic S Corp",
    price: 899,
    description: "Essential S Corp formation",
    popular: false,
    features: [
      "Articles of Incorporation",
      "State Filing",
      "Standard Bylaws",
      "EIN Application",
      "IRS Form 2553 Filing",
      "Initial Stock Issuance"
    ]
  },
  {
    id: 2,
    name: "Complete S Corp",
    price: 1799,
    description: "Full S Corp package",
    popular: true,
    features: [
      "Everything in Basic",
      "Custom Bylaws",
      "Board Resolutions",
      "Stock Purchase Agreements",
      "Shareholder Agreements",
      "Registered Agent (1 Year)",
      "Tax Planning Consultation"
    ]
  },
  {
    id: 3,
    name: "Premium S Corp",
    price: 2799,
    description: "Comprehensive S Corp solution",
    popular: false,
    features: [
      "Everything in Complete",
      "Multi-State Registration",
      "Payroll Setup Assistance",
      "Quarterly Compliance Support",
      "Accounting Software Integration",
      "Ongoing Tax Advisory",
      "Attorney Consultation"
    ]
  }
];

export const nonProfitPricing = [
  {
    id: 1,
    name: "Basic Non-Profit",
    price: 1299,
    description: "Essential 501(c)(3) formation",
    popular: false,
    features: [
      "Articles of Incorporation",
      "State Filing",
      "EIN Application",
      "Standard Bylaws",
      "IRS Form 1023-EZ Preparation",
      "Conflict of Interest Policy"
    ]
  },
  {
    id: 2,
    name: "Complete Non-Profit",
    price: 2499,
    description: "Full 501(c)(3) package",
    popular: true,
    features: [
      "Everything in Basic",
      "IRS Form 1023 Full Application",
      "Custom Bylaws & Policies",
      "State Tax Exemption Applications",
      "Board Governance Documents",
      "Registered Agent (1 Year)",
      "Compliance Calendar"
    ]
  },
  {
    id: 3,
    name: "Premium Non-Profit",
    price: 3999,
    description: "Comprehensive non-profit solution",
    popular: false,
    features: [
      "Everything in Complete",
      "Grant Readiness Package",
      "Board Training Materials",
      "Fundraising Strategy Guide",
      "Multi-State Registration",
      "Ongoing Compliance Support",
      "Attorney Consultation"
    ]
  }
];

export const patentPricing = [
  {
    id: 1,
    name: "Provisional Application",
    price: 2499,
    description: "Establish early filing date",
    popular: false,
    features: [
      "Patent Attorney Drafting",
      "Detailed Description",
      "Informal Drawings",
      "USPTO Filing",
      "1-Year Protection",
      "Conversion Support"
    ]
  },
  {
    id: 2,
    name: "Utility Patent",
    price: 7999,
    description: "Full utility patent application",
    popular: true,
    features: [
      "Everything in Provisional",
      "Multiple Claim Sets",
      "Professional Drawings",
      "Prior Art Search Included",
      "Prosecution Support",
      "20-Year Protection"
    ]
  },
  {
    id: 3,
    name: "Design Patent",
    price: 2999,
    description: "Ornamental design protection",
    popular: false,
    features: [
      "Design Patent Drafting",
      "Professional Design Drawings",
      "Multiple Views",
      "USPTO Filing",
      "15-Year Protection",
      "Prosecution Included"
    ]
  }
];

export const amazonBrandPricing = [
  {
    id: 1,
    name: "Basic",
    price: 599,
    popular: false,
    features: [
      "Brand Registry Enrollment",
      "Trademark Filing Required",
      "Application Assistance",
      "Basic Documentation",
      "Email Support"
    ],
    note: "Essential brand protection"
  },
  {
    id: 2,
    name: "Professional",
    price: 1199,
    popular: true,
    features: [
      "Everything in Basic",
      "Trademark Filing Included",
      "Enhanced Brand Content Setup",
      "Brand Analytics Access",
      "Phone & Email Support",
      "Priority Processing"
    ],
    note: "Complete Amazon protection"
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    popular: false,
    features: [
      "Everything in Professional",
      "Multi-Brand Management",
      "Counterfeit Monitoring",
      "Dedicated Account Manager",
      "24/7 Support",
      "Enforcement Assistance"
    ],
    note: "Full Amazon brand management"
  }
];

export const standardServicePricing = [
  {
    id: 1,
    name: "Basic",
    price: 499,
    popular: false,
    features: [
      "Service Consultation",
      "Document Preparation",
      "Filing Support",
      "Basic Documentation",
      "Email Support"
    ],
    note: "Essential service package"
  },
  {
    id: 2,
    name: "Professional",
    price: 899,
    popular: true,
    features: [
      "Everything in Basic",
      "Priority Processing",
      "Advanced Documentation",
      "Follow-up Support",
      "Phone & Email Support",
      "Status Monitoring"
    ],
    note: "Complete service solution"
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    popular: false,
    features: [
      "Everything in Professional",
      "Dedicated Account Manager",
      "24/7 Priority Support",
      "Ongoing Consultation",
      "Custom Solutions",
      "Full Service Support"
    ],
    note: "Full-service package"
  }
];

// Trademark Clearance Search Pricing
export const clearanceSearchPricing = [
  {
    id: 1,
    name: "Basic Clearance",
    price: 399,
    description: "Essential trademark clearance",
    popular: false,
    features: [
      "USPTO Database Search",
      "Identical Mark Search",
      "Basic Conflict Report",
      "Email Delivery",
      "3-Day Turnaround"
    ]
  },
  {
    id: 2,
    name: "Comprehensive",
    price: 799,
    description: "Complete clearance analysis",
    popular: true,
    features: [
      "Everything in Basic",
      "Common Law Search",
      "State Registrations",
      "Domain Name Search",
      "Attorney Risk Analysis",
      "Strategic Recommendations",
      "48-Hour Rush Available"
    ]
  },
  {
    id: 3,
    name: "International",
    price: 1499,
    description: "Global trademark clearance",
    popular: false,
    features: [
      "Everything in Comprehensive",
      "International Database Search",
      "Madrid Protocol Countries",
      "Global Risk Assessment",
      "Multi-Jurisdiction Analysis",
      "Priority Support"
    ]
  }
];

// Trademark Office Actions Pricing
export const officeActionsPricing = [
  {
    id: 1,
    name: "Simple Response",
    price: 599,
    description: "Minor technical corrections",
    popular: false,
    features: [
      "Attorney Review",
      "Response Preparation",
      "Minor Amendments",
      "Specimen Correction",
      "USPTO Filing"
    ]
  },
  {
    id: 2,
    name: "Standard Response",
    price: 999,
    description: "Complex objection handling",
    popular: true,
    features: [
      "Everything in Simple",
      "Legal Research",
      "Case Law Arguments",
      "Likelihood of Confusion",
      "Descriptiveness Arguments",
      "Examiner Interview"
    ]
  },
  {
    id: 3,
    name: "Appeal Preparation",
    price: 2499,
    description: "TTAB appeal filing",
    popular: false,
    features: [
      "Everything in Standard",
      "Appeal Brief Preparation",
      "Evidence Compilation",
      "TTAB Filing",
      "Appellate Arguments",
      "Full Appeal Support"
    ]
  }
];

// Trademark Monitoring Pricing (Market Standard)
export const monitoringPricing = [
  {
    id: 1,
    name: "Basic Monitoring",
    price: 199,
    description: "Per year | Essential monitoring",
    popular: false,
    features: [
      "USPTO Watch Service",
      "Quarterly Reports",
      "Identical Match Alerts",
      "Email Notifications",
      "12 Months Coverage"
    ]
  },
  {
    id: 2,
    name: "Comprehensive",
    price: 499,
    description: "Per year | Full coverage",
    popular: true,
    features: [
      "Everything in Basic",
      "State Trademark Watch",
      "Domain Name Monitoring",
      "Social Media Scanning",
      "Monthly Reports",
      "Priority Alerts"
    ]
  },
  {
    id: 3,
    name: "Global Monitoring",
    price: 999,
    description: "Per year | Worldwide protection",
    popular: false,
    features: [
      "Everything in Comprehensive",
      "International Trademark Watch",
      "Madrid Protocol Monitoring",
      "Multi-Country Coverage",
      "Bi-Weekly Reports",
      "Dedicated Monitoring Team"
    ]
  }
];

// Statement of Use Pricing (Market Standard)
export const statementOfUsePricing = [
  {
    id: 1,
    name: "Basic Filing",
    price: 299,
    description: "+ USPTO Fee | Essential filing",
    popular: false,
    features: [
      "Statement of Use Preparation",
      "Specimen Review",
      "USPTO Filing",
      "Filing Confirmation",
      "Email Support"
    ]
  },
  {
    id: 2,
    name: "Professional",
    price: 599,
    description: "+ USPTO Fee | Complete service",
    popular: true,
    features: [
      "Everything in Basic",
      "Attorney Review",
      "Specimen Optimization",
      "Extension Requests",
      "Priority Filing",
      "Phone Support"
    ]
  }
];

// Ownership Change/Assignment Pricing (Market Standard)
export const ownershipChangePricing = [
  {
    id: 1,
    name: "Simple Assignment",
    price: 399,
    description: "Basic ownership transfer",
    popular: false,
    features: [
      "Assignment Document Preparation",
      "USPTO Filing",
      "Recording with USPTO",
      "Certificate of Recordation",
      "Email Support"
    ]
  },
  {
    id: 2,
    name: "Complex Assignment",
    price: 799,
    description: "Multiple marks or entities",
    popular: true,
    features: [
      "Everything in Simple",
      "Multiple Trademark Assignments",
      "Legal Review & Analysis",
      "Due Diligence Support",
      "Priority Processing",
      "Phone & Email Support"
    ]
  }
];

